import React from "react";
import useReveal from "./useReveal";

function Experience() {
  const [ref, inView] = useReveal();

  const roles = [
    {
      date: "Jul 2025 \u2014 Jul 2026",
      role: "IT & Development Officer",
      org: "M25 Systems Ltd (M25 Movers) \u00B7 London, UK",
      desc: "Maintained and enhanced a Laravel CRM, built automation workflows, ran operational monitoring on Zoho, and built a Python tool that digitized the company guidebook.",
    },
    {
      date: "May \u2014 Jul 2025",
      role: "Full-Stack Web Developer",
      org: "Ibotika \u00B7 Iligan City, PH",
      desc: "Built and deployed a dental clinic web app for appointment scheduling and procedure management using Laravel, PHP, and SQL.",
    },
    {
      date: "Mar \u2014 May 2025",
      role: "Executive Graphic Designer",
      org: "Dotted Studios \u00B7 Iligan City, PH",
      desc: "Specialized in video editing and animation; developed an internal attendance tracking system.",
    },
    {
      date: "Dec 2024 \u2014 Mar 2025",
      role: "Video Editor | Web Developer Intern",
      org: "Dotted Studios \u00B7 Iligan City, PH",
      desc: "Produced motion graphics for client brands, built a dentist-office web app, and shipped a passion project: an AI flash-card generator.",
    },
    {
      date: "Aug 2023 \u2014 Jun 2024",
      role: "Data Encoder",
      org: "Tadman 2022, MSU-IIT Yearbook (OSDS) \u00B7 Iligan City, PH",
      desc: "Verified and cleaned data using pandas, corrected errors, and streamlined the data-entry workflow for the whole team.",
    },
  ];

  return React.createElement(
    "section",
    {
      id: "experience",
      ref: ref,
      className: "experience section reveal" + (inView ? " in-view" : ""),
    },
    React.createElement("p", { className: "eyebrow" }, "02 \u2014 Experience"),
    React.createElement(
      "h2",
      { className: "section-title" },
      "Where I've worked",
    ),
    React.createElement(
      "div",
      { className: "timeline" },
      roles.map(function (item, i) {
        return React.createElement(
          "div",
          {
            className: "timeline-item",
            key: i,
            style: { "--i": i },
          },
          React.createElement("div", { className: "timeline-marker" }),
          React.createElement(
            "span",
            { className: "timeline-date" },
            item.date,
          ),
          React.createElement("h3", { className: "timeline-role" }, item.role),
          React.createElement("p", { className: "timeline-org" }, item.org),
          React.createElement("p", { className: "timeline-desc" }, item.desc),
        );
      }),
    ),
  );
}

export default Experience;
